import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'app-task-status2',
    template: '<div [ngClass]="stylingClass" (click)="openDialog()"><label class="status-type">{{value}}</label></div>',
    styleUrls: ['./task-status2.component.scss'],
    standalone: false ,  // NOSONAR
})


export class TaskStatus2Component implements OnInit {

    public value = '';
    public stylingClass;
    public status;
    isEditable = false;
    params;

    /** Compute initials from email */
    getInitialsFromEmail(email: string): string {
        if (!email) {return ''};
        try {
            const clean = email.split('@')[0]; 
            const parts = clean.split('.');
            const first = parts[0]?.charAt(0) ?? '';
            const last = parts[parts.length - 1]?.charAt(0) ?? '';
            return (first + last).toUpperCase();
        } catch {
            return '';
        }
    }

    agInit(params: ICellRendererParams): void {

        this.params = params;

        const currentdate = new Date();
        const dueDate = new Date(this.params.data.DUE);

        if (params.value) {

            const regionData = params.value.split("|");

            /** Now compute correct initials */
            this.value = this.getInitialsFromEmail(regionData[1]);

            if (regionData[3] == '1') { // NOSONAR
                this.isEditable = true;
            }

            if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
                this.status = regionData[0];
            }
            else if (dueDate >= currentdate) {
                this.status = regionData[0];
            }
            else if (dueDate < currentdate) {
                this.status = "P";
            }
        }

        if (this.status == "O") { // NOSONAR
            // white
            this.stylingClass = this.isEditable ? "status-box-white-pointer" : "status-box-white";
        } else if (this.status == "P") { // NOSONAR
            // red
            this.stylingClass = this.isEditable ? "status-box-pointer" : "status-box";
        }
    }

    openDialog() {
        if (!this.isEditable) {return;}

        if (this.status == "O") { // NOSONAR
            this.params.context.componentParent.MACOpenStatusChangeDialog(this.params);
        }
        else if (this.status == "P") { // NOSONAR
            this.params.context.componentParent.MACPastStatusChangeDialog(this.params);
        }
    }

    constructor(public dialog: MatDialog) { }
    ngOnInit() { // NOSONAR
        // do nothing
     }
}
